export default {
    items: state => {
        return state.items;
    },
}
